import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const PhoneIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.79003 4C4.62999 4 3.87328 4.9112 4.02764 5.81917C5.24576 12.9841 11.016 18.7543 18.1809 19.9724C19.0888 20.1267 20 19.37 20 18.21V17.2674C20 16.8086 19.6877 16.4086 19.2426 16.2973L17.0123 15.7397L16.3454 16.2908L16.3436 16.2924L15.2841 17.1679C14.9846 17.4154 14.5689 17.467 14.218 17.3003C10.9274 15.7371 8.26286 13.0726 6.69967 9.78203C6.53297 9.43111 6.5846 9.01539 6.83209 8.71592L8.26029 6.9877L7.70273 4.75746C7.59144 4.3123 7.19145 4 6.73259 4H5.79003ZM2.05594 6.15438C1.6549 3.79552 3.63635 2 5.79003 2H6.73259C8.10919 2 9.30914 2.93689 9.64301 4.27239L10.3231 6.99276C10.4002 7.30096 10.3262 7.62743 10.1238 7.87232L8.7896 9.4868C10.0837 11.9173 12.0828 13.9163 14.5132 15.2104L15.0664 14.7533L15.0683 14.7517L16.1277 13.8762C16.3726 13.6738 16.6991 13.5999 17.0073 13.6769L19.7276 14.357C21.0631 14.6909 22 15.8908 22 17.2674V18.21C22 20.3637 20.2045 22.3451 17.8456 21.9441C9.84297 20.5835 3.41649 14.157 2.05594 6.15438Z"
          fill="#006DFF"
        />
      </svg>
    );
  }
);

export default PhoneIcon;
